import { collections, type Collection } from "@/mocks/homeContent";

function CollectionCard({ c }: { c: Collection }) {
  return (
    <article className="flex flex-col overflow-hidden rounded-2xl border border-secondary-200/70 bg-background-50">
      {/* 卡头 */}
      <div className="flex items-center gap-3 px-5 pt-5">
        <span
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br text-background-50 ${c.accent}`}
        >
          <i className={`${c.icon} text-lg leading-none`}></i>
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-medium uppercase tracking-wider text-foreground-400">{c.kicker}</p>
          <h3 className="text-base font-black leading-6 text-foreground-950">{c.name}</h3>
        </div>
        <span className="shrink-0 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-semibold text-accent-800">
          <i className="ri-fire-line mr-0.5 align-[-1px] text-xs"></i>
          {c.trendLabel}
        </span>
      </div>

      <p className="px-5 pt-2 text-xs leading-5 text-foreground-500">{c.desc}</p>

      {/* 标题+短摘要列表 */}
      <ul className="mt-3 flex flex-col divide-y divide-secondary-100 border-t border-secondary-100 px-2 py-1">
        {c.items.map((it, i) => (
          <li key={i}>
            <a href="#topics" className="group block rounded-lg px-3 py-3 transition-colors hover:bg-background-100">
              <div className="flex items-start gap-2.5">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-400"></span>
                <div className="min-w-0">
                  <h4 className="text-sm font-semibold leading-6 text-foreground-900 group-hover:text-primary-700">
                    {it.title}
                  </h4>
                  <p className="mt-0.5 line-clamp-2 text-xs leading-5 text-foreground-500">{it.summary}</p>
                </div>
              </div>
              <div className="mt-2 flex items-center justify-between pl-4">
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-700">
                  {it.tag}
                </span>
                <span className="inline-flex items-center gap-1 text-[11px] font-medium text-secondary-500 group-hover:text-primary-600">
                  展开
                  <i className="ri-arrow-right-up-line text-sm leading-none"></i>
                </span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </article>
  );
}

export default function Collections() {
  return (
    <section id="topics" className="py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-end">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              圈层专题合集
              <span className="hidden items-center gap-1 rounded-full bg-primary-100 px-2.5 py-1 text-xs font-semibold text-primary-700 sm:inline-flex">
                <i className="ri-stack-fill text-sm leading-none"></i>
                持续更新
              </span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">按圈子归拢的瓜田，一个专题把来龙去脉看明白。</p>
          </div>
          <p className="text-xs text-foreground-400">共 {collections.length} 个专题</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2">
          {collections.map((c) => (
            <CollectionCard key={c.id} c={c} />
          ))}
        </div>
      </div>
    </section>
  );
}